__turbopack_context__.v({
  "aiSearchModeTab": "c_0Vhq_aiSearchModeTab",
  "aiSearchOverline": "c_0Vhq_aiSearchOverline",
  "backButtonWrapper": "c_0Vhq_backButtonWrapper",
  "classicSearchModeTab": "c_0Vhq_classicSearchModeTab",
  "classicSearchOverline": "c_0Vhq_classicSearchOverline",
  "mobileAutoComplete": "c_0Vhq_mobileAutoComplete",
  "modeTab": "c_0Vhq_modeTab",
  "searchModeTabs": "c_0Vhq_searchModeTabs",
  "tabsContainer": "c_0Vhq_tabsContainer",
});
